import { BrannanWebsiteHeaderSettings } from '@apps/guest/websiteHeader';
import React from 'react';
import { HeaderV2Props, HeaderV2 } from '../HeaderV2';
import { Header } from '../Header';

export interface WebsiteHeaderProps extends Omit<HeaderV2Props, 'websiteHeader'> {
  websiteHeader: Maybe<BrannanWebsiteHeaderSettings['websiteHeader']>;
  pageId?: string;
  eventDisplayName: Maybe<string>;
}

const WebsiteHeader = ({ eventDisplayName, pageId, websiteHeader, ...restProps }: WebsiteHeaderProps) => {
  // The V2 set of website header layouts essentially use the existing brannan event name + nav structure.
  // The V3+ following sets will be unique and not share the legacy structure.
  return websiteHeader ? (
    <>
      <HeaderV2
        {...restProps}
        websiteHeader={websiteHeader}
        pageId={pageId}
      />
    </>
  ) : (
    <Header
      {...restProps}
      eventDisplayName={eventDisplayName}
    />
  );
};

export default WebsiteHeader;
